/**
 * SchoolClubsSummaryCards — extracted from SchoolClubsPage during Iter28 refactor.
 *
 * Renders the 3 top-level stat cards (Total Clubs / Total Members /
 * Active Projects). Pure presentational.
 */
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '../ui/card';

const SchoolClubsSummaryCards = ({ clubs = [], members = [] }) => {
  const activeProjects = clubs.filter((c) => c.project_status === 'in_progress').length;
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="school-clubs-summary-cards">
      <Card data-testid="clubs-stat-total">
        <CardHeader className="pb-2">
          <CardDescription>Total Clubs</CardDescription>
          <CardTitle className="text-3xl">{clubs.length}</CardTitle>
        </CardHeader>
      </Card>
      <Card data-testid="clubs-stat-members">
        <CardHeader className="pb-2">
          <CardDescription>Total Members</CardDescription>
          <CardTitle className="text-3xl">{members.length}</CardTitle>
        </CardHeader>
      </Card>
      <Card data-testid="clubs-stat-active-projects">
        <CardHeader className="pb-2">
          <CardDescription>Active Projects</CardDescription>
          <CardTitle className="text-3xl">{activeProjects}</CardTitle>
        </CardHeader>
      </Card>
    </div>
  );
};

export default SchoolClubsSummaryCards;
